<template>
  <v-form
    ref="form-steps"
    v-bind="$attrs"
    v-on="$listeners"
    class="pa-2"
  >
    <div class="mb-5 d-flex justify-center">
      <avs-createButton
        @click.stop="createStep"
        :name="$t('actions.new_female', { entity: $t('commons.activity').toLowerCase() })"
        :spantext="$t('actions.add', { entity: $t('commons.activity').toLowerCase() })"
      >
      </avs-createButton>
    </div>

    <v-expansion-panels
      focusable
      v-model="panelOpen"
    >
      <v-expansion-panel
        v-for="(step, stepIndex) in this.project.steps"
        :key="stepIndex"
      >
        <v-expansion-panel-header class="d-flex align-center">
          <div class="d-flex align-center justify-space-between">
            <v-col cols="3">
              <span class="primary--text font-weight-bold">{{ step.name }}</span>
            </v-col>
            <v-col cols="3">
              <span class="secondary--text">
                {{ $t("commons.date.start_date") }} : <b>{{ toDatetime(step.start_date) }}</b>
              </span>
            </v-col>
            <v-col cols="3">
              <span class="secondary--text">
                {{ $t("commons.date.end_date") }} : <b>{{ toDatetime(step.deadline) }}</b>
              </span>
            </v-col>
            <v-col cols="2">
              <avs-chip>
                {{ $tc("commons.task", 2).toUpperCase() }} ({{ step.tasks.length }})</avs-chip
              >
            </v-col>
            <avs-deleteButton
              @click="openDeleteDialog(stepIndex)"
              :spantext="$t('actions.delete', { entity: $t('commons.activity').toLowerCase() })"
            />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <ProjectActivityTask
            :maxDatetime="project.end_date"
            :minDatetime="project.start_date"
            :step="step"
            :pcq_dsi="pcq_dsi"
            :rulesUpdate="getRulesUpdate(stepIndex)"
            @updated="hasBeenUpdated"
          />
          <ProjectActivityInspection
            :maxDatetime="project.end_date"
            :minDatetime="project.start_date"
            :step="step"
            :rulesUpdate="getRulesUpdate(stepIndex)"
            @updated="hasBeenUpdated"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="closeDeleteDialog"
      @delete="deleteStep"
      resource="activity"
    />
  </v-form>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"
import { mkProjectStep } from "@/utils/datamodels"
import { toDatetime } from "@/utils/datetime"
import { StepService } from "@/services"
import { required, mkUnique } from "@/utils/validator"

export default {
  name: "ProjectActivityList",
  components: {
    ProjectActivityTask: () => import("@/components/ri3/project/ProjectActivityTask.vue"),
    ProjectActivityInspection: () =>
      import("@/components/ri3/project/ProjectActivityInspection.vue")
  },
  props: {
    project: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    pcq_dsi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stepIndex: null,
      deleteDialogIsOpen: false,
      panelOpen: null
    }
  },
  computed: {
    expansionStyle() {
      return { backgroundColor: getTheme(this).bgExpansion }
    }
  },
  methods: {
    toDatetime,
    getRulesUpdate(index) {
      let othernames = this.project.steps.filter((e, i) => i !== index).map(e => e.name)
      return { name: [required, mkUnique(othernames, "name")] }
    },
    hasBeenUpdated() {
      this.$emit("updated")
    },
    createStep() {
      let order = this.project.steps.length + 1
      this.project.steps.push(
        mkProjectStep(this.project.start_date, order, this.$t("commons.activity").toUpperCase())
      )
      this.panelOpen = this.project.steps.length - 1
    },
    deleteStep() {
      let step = this.project.steps[this.stepIndex]
      if (step.id) {
        StepService.remove(this, step.id).then(response => {
          this.send(
            this.$t("messages.success.deleted", { entity: this.$t("commons.activity") }),
            "success"
          )
        })
        this.hasBeenUpdated()
      } else {
        this.project.steps.splice(this.stepIndex, 1)
        this.send(
          this.$t("messages.success.deleted", { entity: this.$t("commons.activity") }),
          "success"
        )
      }
      this.deleteDialogIsOpen = false
    },
    closeDeleteDialog() {
      this.deleteDialogIsOpen = false
    },
    openDeleteDialog(stepIndex) {
      this.deleteDialogIsOpen = true
      this.stepIndex = stepIndex
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    validate() {
      return this.$refs["form-steps"].validate()
    }
  }
}
</script>
